"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconFilter = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M59.63 7.72H11.55a2.08 2.08 0 0 0-1.47 3.55l20.86 20.85v25.53A6.12 6.12 0 0 0 32.73 62l4.9 4.9a1.53 1.53 0 0 0 2.61-1.08v-33.7L61.1 11.27a2.08 2.08 0 0 0-1.47-3.55z"
  })),
  height: undefined,
  width: undefined
});
IconFilter.displayName = 'IconFilter';
var _default = IconFilter;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/filter.js
// module id = 565
// module chunks = 0